export default __webpack_public_path__ + "static/media/plain-sticker-D.86f80aef.png";